// const ServerUrl: string = "https://www.api.dearlanguage.com";

const ServerUrl: string = 'http://localhost:8000';

export default ServerUrl;
